import { Storage, Keys } from '.';

/**
 * Return the saved token from the storage.
 */
export function getToken() {
    return Storage.get(Keys.TOKEN);
}

/**
 * Check if there is a token saved in the storage.
 */
export function isAuthenticated() {
    return Storage.get(Keys.TOKEN) ? true : false;
}

/**
 * Save the token to the local storage.
 * @param {String} token 
 */
export function setAuthenticated(token) {
    Storage.set(Keys.TOKEN, token);
}
